'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tabbable = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]'];

var findTabbable = function findTabbable(element) {
  if (element) {
    var tabbableElements = element.querySelectorAll(tabbable.join(','));
    return tabbableElements;
  }
};

var setTabbable = exports.setTabbable = function setTabbable(element) {
  if (element) {
    var tabbableElements = findTabbable(element);
    return {
      first: tabbableElements[0],
      last: tabbableElements[tabbableElements.length - 1]
    };
  }
};